var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 256 } },
              [
                _c("q-input", {
                  ref: "title",
                  attrs: {
                    "float-label": _vm.$t("title"),
                    error: _vm.$v.title.$error,
                    disable: !_vm.managerTrainings
                  },
                  on: { input: _vm.$v.title.$touch },
                  model: {
                    value: _vm.title,
                    callback: function($$v) {
                      _vm.title = $$v
                    },
                    expression: "title"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("span", { staticClass: "caption q-mb-sm block" }, [
              _vm._v(_vm._s(_vm.$t("introduction")))
            ]),
            _c(
              "q-field",
              { attrs: { count: 1024 } },
              [
                _c("q-input", {
                  staticStyle: { display: "none" },
                  model: {
                    value: _vm.descriptionWithoutHTML,
                    callback: function($$v) {
                      _vm.descriptionWithoutHTML = $$v
                    },
                    expression: "descriptionWithoutHTML"
                  }
                }),
                _c(
                  "q-editor",
                  {
                    attrs: {
                      "content-style": _vm.$v.descriptionWithoutHTML.$error
                        ? { border: "1px solid red" }
                        : {},
                      toolbar: [
                        ["bold", "italic", "strike", "underline"],
                        ["left", "center", "right", "justify"],
                        ["link", "upload"],
                        [
                          {
                            label: null,
                            icon: "fas fa-font",
                            fixedLabel: true,
                            fixedIcon: true,
                            list: "no-icons",
                            options: [
                              "p",
                              "h1",
                              "h2",
                              "h3",
                              "h4",
                              "h5",
                              "h6",
                              "code"
                            ]
                          },
                          {
                            label: null,
                            icon: "fas fa-text-height",
                            fixedLabel: true,
                            fixedIcon: true,
                            list: "no-icons",
                            options: [
                              "size-1",
                              "size-2",
                              "size-3",
                              "size-4",
                              "size-5",
                              "size-6",
                              "size-7"
                            ]
                          },
                          "removeFormat"
                        ],
                        ["quote", "unordered", "ordered"],
                        ["custom_btn"]
                      ],
                      definitions: {
                        bold: { label: null, icon: "fas fa-bold" },
                        italic: { label: null, icon: "fas fa-italic" },
                        strike: { label: null, icon: "fas fa-strikethrough" },
                        underline: { label: null, icon: "fas fa-underline" },
                        left: { label: null, icon: "fas fa-align-left" },
                        center: { label: null, icon: "fas fa-align-center" },
                        right: { label: null, icon: "fas fa-align-right" },
                        justify: { label: null, icon: "fas fa-align-justify" },
                        link: { label: null, icon: "fas fa-link" },
                        upload: {
                          tip: null,
                          icon: "fas fa-file-image",
                          handler: _vm.insertImg
                        },
                        removeFormat: { label: null, icon: "fas fa-eraser" },
                        quote: { label: null, icon: "fas fa-quote-right" },
                        unordered: { label: null, icon: "fas fa-list-ul" },
                        ordered: { label: null, icon: "fas fa-list-ol" }
                      }
                    },
                    on: { input: _vm.$v.descriptionWithoutHTML.$touch },
                    model: {
                      value: _vm.description,
                      callback: function($$v) {
                        _vm.description = $$v
                      },
                      expression: "description"
                    }
                  },
                  [
                    _c("q-btn", {
                      attrs: {
                        slot: "custom_btn",
                        dense: "",
                        flat: "",
                        color: "black",
                        icon: "fal fa-code",
                        label: "HTML"
                      },
                      on: {
                        click: function($event) {
                          _vm.show_description_html = true
                        }
                      },
                      slot: "custom_btn"
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm.selected_client_params.group_training_use_basic
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-select", {
                  ref: "group_training_type",
                  attrs: {
                    options: _vm.group_training_types,
                    "float-label": _vm.$t("capacitation"),
                    error: _vm.$v.group_training_type.$error,
                    disable: !_vm.managerTrainings
                  },
                  on: { input: _vm.$v.group_training_type.$touch },
                  model: {
                    value: _vm.group_training_type,
                    callback: function($$v) {
                      _vm.group_training_type = $$v
                    },
                    expression: "group_training_type"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.selected_client_params.group_training_use_score &&
        _vm.trainingTypeUseScore
          ? _c(
              "div",
              {
                ref: "score",
                staticClass: "col-xs-12",
                class:
                  _vm.selected_client_params.group_training_use_workload &&
                  "col-sm-6"
              },
              [
                !_vm.selected_client_params.group_training_use_static_score
                  ? _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("score"),
                        type: "number",
                        error: _vm.$v.score.$error,
                        disable: !_vm.set_score || !_vm.managerTrainings
                      },
                      on: { input: _vm.$v.score.$touch },
                      model: {
                        value: _vm.score,
                        callback: function($$v) {
                          _vm.score = $$v
                        },
                        expression: "score"
                      }
                    })
                  : _vm._e(),
                _vm.selected_client_params.group_training_use_static_score
                  ? _c("q-select", {
                      attrs: {
                        options: _vm.scoresOptions,
                        "float-label": _vm.$t("score"),
                        error: _vm.$v.score.$error,
                        disable: !_vm.set_score || !_vm.managerTrainings
                      },
                      on: { input: _vm.$v.score.$touch },
                      model: {
                        value: _vm.score,
                        callback: function($$v) {
                          _vm.score = $$v
                        },
                        expression: "score"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm.selected_client_params.group_training_use_workload
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  ref: "workload",
                  attrs: {
                    "float-label": _vm.$t("workload_in_hours"),
                    type: "number",
                    error: _vm.$v.workload.$error,
                    disable: !_vm.managerTrainings
                  },
                  on: { input: _vm.$v.workload.$touch },
                  model: {
                    value: _vm.workload,
                    callback: function($$v) {
                      _vm.workload = $$v
                    },
                    expression: "workload"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.isEnableCode
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-field",
                  { attrs: { helper: _vm.$t("training_code_helper_message") } },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "text",
                        "float-label": _vm.$t("training_code"),
                        disable: !_vm.managerTrainings
                      },
                      model: {
                        value: _vm.code,
                        callback: function($$v) {
                          _vm.code = $$v
                        },
                        expression: "code"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.isSence
        ? _c(
            "div",
            { staticClass: "row q-mb-lg" },
            [
              _c(
                "q-card",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "q-card-title",
                    {
                      staticClass: "bg-blue text-white",
                      staticStyle: { height: "60px" }
                    },
                    [
                      _c("q-checkbox", {
                        staticClass: "q-mb-md",
                        attrs: {
                          "keep-color": "",
                          color: "white",
                          label: _vm.$t("sence_integration")
                        },
                        model: {
                          value: _vm.hasSence,
                          callback: function($$v) {
                            _vm.hasSence = $$v
                          },
                          expression: "hasSence"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.hasSence
                    ? _c("q-card-main", [
                        _c("div", { staticClass: "row gutter-sm" }, [
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-6" },
                            [
                              _c(
                                "q-field",
                                {
                                  attrs: { helper: _vm.$t("sence_code_hint") }
                                },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      type: "text",
                                      "float-label": _vm.$t("sence_code"),
                                      error: _vm.$v.sence.cod_sence.$error
                                    },
                                    on: {
                                      input: _vm.$v.sence.cod_sence.$touch
                                    },
                                    model: {
                                      value: _vm.sence.cod_sence,
                                      callback: function($$v) {
                                        _vm.$set(_vm.sence, "cod_sence", $$v)
                                      },
                                      expression: "sence.cod_sence"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-6" },
                            [
                              _c(
                                "q-field",
                                [
                                  _c("q-input", {
                                    attrs: {
                                      type: "text",
                                      "float-label": _vm.$t("sence_course"),
                                      error: _vm.$v.sence.cod_curso.$error
                                    },
                                    on: {
                                      input: _vm.$v.sence.cod_curso.$touch
                                    },
                                    model: {
                                      value: _vm.sence.cod_curso,
                                      callback: function($$v) {
                                        _vm.$set(_vm.sence, "cod_curso", $$v)
                                      },
                                      expression: "sence.cod_curso"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              ref: "tag",
              attrs: {
                options: _vm.optionTags,
                "float-label": _vm.$t("tags"),
                error: _vm.$v.tag.$error,
                multiple: "",
                chips: "",
                filter: "",
                "autofocus-filter": "",
                disable: !_vm.managerTrainings
              },
              on: { input: _vm.$v.tag.$touch },
              model: {
                value: _vm.tag,
                callback: function($$v) {
                  _vm.tag = $$v
                },
                expression: "tag"
              }
            })
          ],
          1
        ),
        _vm.login_use_portfolio_page
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-select", {
                  ref: "on_portfolio",
                  attrs: {
                    options: [
                      { value: true, label: _vm.$t("yes") },
                      { value: false, label: _vm.$t("no") }
                    ],
                    "float-label": _vm.$t("show_course_on_portfolio"),
                    disable: !_vm.managerTrainings
                  },
                  model: {
                    value: _vm.on_portfolio,
                    callback: function($$v) {
                      _vm.on_portfolio = $$v
                    },
                    expression: "on_portfolio"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "col-xs-12 col-sm-12 " }, [
          _c("div", { staticClass: "row gutter-sm flex" }, [
            _vm.id_training && _vm.isBoticario
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("certificate")))
                    ]),
                    _c("uploader", {
                      attrs: {
                        content_type: "images",
                        multiple: false,
                        filename: "certificate",
                        id: _vm.id_training,
                        custom_certificate_module_path: "group_trainings",
                        disable: !_vm.managerTrainings
                      },
                      on: { fileUploaded: _vm.certificateImageUploaded }
                    }),
                    _vm.certificate_image_url
                      ? _c(
                          "p",
                          { staticClass: "q-mt-md file-url" },
                          [
                            _c("q-icon", {
                              attrs: { name: "fal fa-check", color: "positive" }
                            }),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.certificate_image_url,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$truncateLink(
                                        _vm.certificate_image_url
                                      )
                                    )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.$t("image")))
                ]),
                _c("uploader", {
                  attrs: {
                    content_type: "images",
                    multiple: false,
                    cropper: _vm.isPFSG ? false : true,
                    aspect_ratio: 16 / 9,
                    aspect_ratio_string: "16/9",
                    disable: !_vm.managerTrainings
                  },
                  on: { fileUploaded: _vm.imageUploaded }
                }),
                _vm.image_url
                  ? _c(
                      "p",
                      { staticClass: "q-mt-md file-url" },
                      [
                        _c("q-icon", {
                          attrs: { name: "fal fa-check", color: "positive" }
                        }),
                        _c(
                          "a",
                          { attrs: { href: _vm.image_url, target: "_blank" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$truncateLink(_vm.image_url))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
              _c(
                "p",
                { staticClass: "caption" },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("alt_image")) +
                      "\n\t\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("alt_image_information_helper")) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex justify-between" },
                [
                  _vm._l(_vm.languages, function(lang) {
                    return [
                      lang.code === "pt-br"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_br",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_br.$error
                                },
                                on: { input: _vm.$v.language_br.$touch },
                                model: {
                                  value: _vm.language_br,
                                  callback: function($$v) {
                                    _vm.language_br = $$v
                                  },
                                  expression: "language_br"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "en-us"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_us",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_us.$error
                                },
                                on: { input: _vm.$v.language_us.$touch },
                                model: {
                                  value: _vm.language_us,
                                  callback: function($$v) {
                                    _vm.language_us = $$v
                                  },
                                  expression: "language_us"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "es-es"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_es",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_es.$error
                                },
                                on: { input: _vm.$v.language_es.$touch },
                                model: {
                                  value: _vm.language_es,
                                  callback: function($$v) {
                                    _vm.language_es = $$v
                                  },
                                  expression: "language_es"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "fr-fr"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_fr",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_fr.$error
                                },
                                on: { input: _vm.$v.language_fr.$touch },
                                model: {
                                  value: _vm.language_fr,
                                  callback: function($$v) {
                                    _vm.language_fr = $$v
                                  },
                                  expression: "language_fr"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c(
              "q-field",
              {
                attrs: {
                  helper: "" + _vm.$t("date_for_training_to_be_unpublished")
                }
              },
              [
                _c("q-datetime", {
                  ref: "unpublish_date",
                  attrs: {
                    type: "date",
                    "float-label": _vm.$t("unpublish_date"),
                    format: "DD/MM/YYYY",
                    clearable: "",
                    disable: !_vm.managerTrainings
                  },
                  model: {
                    value: _vm.unpublish_date,
                    callback: function($$v) {
                      _vm.unpublish_date = $$v
                    },
                    expression: "unpublish_date"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _vm.selected_client_params
              .use_group_trainings_certificate_expiration
              ? _c("inputExpireCertificate", {
                  ref: "inputExpireCertificate",
                  attrs: {
                    disableInput: !_vm.managerTrainings,
                    qty_days: _vm.qty_days
                  },
                  on: { fnInDays: _vm.fnInDays }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fal fa-clipboard-list-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("areas")))
                    ]),
                    _c("q-checkbox", {
                      staticClass: "q-mb-sm",
                      attrs: {
                        disable: !_vm.managerTrainings,
                        val: true,
                        label: _vm.$t("select_all_areas")
                      },
                      on: {
                        input: function($event) {
                          return _vm.checkAllAreas()
                        }
                      },
                      model: {
                        value: _vm.all_areas,
                        callback: function($$v) {
                          _vm.all_areas = $$v
                        },
                        expression: "all_areas"
                      }
                    }),
                    _c("select-multiple", {
                      attrs: {
                        label: "",
                        filters: _vm.area,
                        options: _vm.areas,
                        error: _vm.$v.area.$error,
                        input: _vm.changeAreas,
                        disable: !_vm.managerTrainings
                      },
                      on: {
                        on_value: function($event) {
                          _vm.area = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: {
                              val: true,
                              label: _vm.$t("all"),
                              disable: !_vm.managerTrainings
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profile.$error)
                          },
                          [
                            _c("q-checkbox", {
                              ref: "profile",
                              refInFor: true,
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profile.$error),
                                disable: !_vm.managerTrainings
                              },
                              on: {
                                input: function($event) {
                                  return _vm.changeProfiles()
                                }
                              },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm.useTrainingSubscription
                ? _c("div", { staticClass: "row gutter-sm q-mt-md" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("p", { staticClass: "caption" }, [
                          _vm._v(_vm._s(_vm.$t("mandatory_areas")))
                        ]),
                        _c("q-checkbox", {
                          staticClass: "q-mb-sm",
                          attrs: {
                            disable: !_vm.managerTrainings,
                            val: true,
                            label: _vm.$t("select_all_areas")
                          },
                          on: {
                            input: function($event) {
                              return _vm.checkAllMandatoryAreas()
                            }
                          },
                          model: {
                            value: _vm.all_mandatory_areas,
                            callback: function($$v) {
                              _vm.all_mandatory_areas = $$v
                            },
                            expression: "all_mandatory_areas"
                          }
                        }),
                        _c("select-multiple", {
                          attrs: {
                            label: "",
                            filters: _vm.mandatory_areas,
                            options: _vm.mandatoryAreas,
                            error: _vm.$v.mandatory_areas.$error,
                            input: _vm.$v.mandatory_areas.$touch,
                            disable: !_vm.managerTrainings
                          },
                          on: {
                            on_value: function($event) {
                              _vm.mandatory_areas = $event
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("mandatory_profiles")))
                      ]),
                      _c(
                        "div",
                        { staticClass: "row gutter-sm" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-12" },
                            [
                              _c("q-checkbox", {
                                attrs: {
                                  val: true,
                                  label: _vm.$t("all"),
                                  disable: !_vm.managerTrainings
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.checkAllMandatoryProfiles()
                                  }
                                },
                                model: {
                                  value: _vm.all_mandatory_profiles,
                                  callback: function($$v) {
                                    _vm.all_mandatory_profiles = $$v
                                  },
                                  expression: "all_mandatory_profiles"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._l(_vm.mandatoryProfiles, function(item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "col-xs-12 col-sm-4" },
                              [
                                _c("q-checkbox", {
                                  ref: "mandatory_profiles",
                                  refInFor: true,
                                  attrs: {
                                    "keep-color": "",
                                    val: item.value,
                                    label: item.label,
                                    error: _vm.$v.mandatory_profiles.$error,
                                    disable: !_vm.managerTrainings
                                  },
                                  on: {
                                    input: _vm.$v.mandatory_profiles.$touch
                                  },
                                  model: {
                                    value: _vm.mandatory_profiles,
                                    callback: function($$v) {
                                      _vm.mandatory_profiles = $$v
                                    },
                                    expression: "mandatory_profiles"
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      ref: "user_group",
                      attrs: {
                        options: _vm.user_groups,
                        "float-label": _vm.$t("groups"),
                        error: _vm.$v.user_group.$error,
                        multiple: "",
                        chips: "",
                        disable: !_vm.managerTrainings
                      },
                      on: { input: _vm.$v.user_group.$touch },
                      model: {
                        value: _vm.user_group,
                        callback: function($$v) {
                          _vm.user_group = $$v
                        },
                        expression: "user_group"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm.id_training != 0
                ? _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-11" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("link"),
                            disable: true
                          },
                          model: {
                            value: _vm.url_training_portal,
                            callback: function($$v) {
                              _vm.url_training_portal = $$v
                            },
                            expression: "url_training_portal"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-1 q-mt-lg" },
                      [
                        _c(
                          "q-btn",
                          {
                            staticClass: "full-width",
                            attrs: {
                              dense: "",
                              color: "primary",
                              icon: "fal fa-copy"
                            },
                            on: {
                              click: function($event) {
                                return _vm.copyLink()
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("copy_link")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-mt-xs" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "q-chips-input",
              {
                attrs: {
                  "float-label": _vm.$t("owners"),
                  disable: !_vm.managerTrainings
                },
                on: { remove: _vm.removeOwner },
                model: {
                  value: _vm.owners_list,
                  callback: function($$v) {
                    _vm.owners_list = $$v
                  },
                  expression: "owners_list"
                }
              },
              [
                _c("q-autocomplete", {
                  attrs: {
                    "min-characters": 3,
                    "value-field": function(v) {
                      return v.full_name + " - " + v.email
                    }
                  },
                  on: { search: _vm.searchOwner, selected: _vm.selectOwner }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_trainings" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save",
                disable: !_vm.managerTrainings
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_description_html,
            callback: function($$v) {
              _vm.show_description_html = $$v
            },
            expression: "show_description_html"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_description_html = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [_vm._v("\n\t\t\t\t\tHTML\n\t\t\t\t")])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          rows: "10",
                          "float-label": "HTML"
                        },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "far fa-ban"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_description_html = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }